import { useEffect, useState } from "react";
import { useWizardProgress } from "@/hooks/useWizardProgress";

interface TermsState {
  termsOfUse: boolean;
  privacyPolicy: boolean;
}

export const useTermsOfService = () => {
  const [agreedToTerms, setAgreedToTerms] = useState<TermsState>({
    termsOfUse: false,
    privacyPolicy: false,
  });

  const { saveTermsAcceptance, progress } = useWizardProgress();

  useEffect(() => {
    // If all terms were previously accepted, set all to true
    if (progress.terms_accepted) {
      setAgreedToTerms({
        termsOfUse: true,
        privacyPolicy: true,
      });
    }
  }, [progress.terms_accepted]);

  const handleTermsChange = (
    termType: "termsOfUse" | "privacyPolicy",
    checked: boolean,
  ) => {
    const updatedTerms = {
      ...agreedToTerms,
      [termType]: checked,
    };

    setAgreedToTerms(updatedTerms);
  };

  const saveTermsAcceptanceAfterSubmit = () => {
    saveTermsAcceptance(true);
  };

  const allTermsAccepted =
    agreedToTerms.termsOfUse && agreedToTerms.privacyPolicy;

  return {
    agreedToTerms,
    handleTermsChange,
    allTermsAccepted,
    saveTermsAcceptanceAfterSubmit,
  };
};
